

<template>
  <div id="contact-form">
    <Loader :active="loading"></Loader>

    <div class="columns">
      <div class="column is-6">
        <div class="level is-mobile">
          <div class="level-left">
            <div class="level-item">
              <div>
                <h1 class="title has-text-primary">Editar Contacto</h1>
                <nav class="breadcrumb" aria-label="breadcrumbs">
                  <ul>
                    <li>
                      <router-link :to="'/contactos'">Contactos</router-link>
                    </li>
                    <li class="is-active">
                      <a href="#">Editar Contacto </a>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="columns">
      <div class="column is-6">
        <b-tabs>
          <b-tab-item label="Información">
            <form @submit.prevent="update">
              <!-- Campos básicos -->
              <b-field label="Procedencia"
                ><b-input v-model="origin" disabled></b-input
              ></b-field>
              <b-field label="Nombre y Apellido*"
                ><b-input v-model="fullname" required></b-input
              ></b-field>
              <b-field label="Email*"
                ><b-input v-model="email" type="email" required></b-input
              ></b-field>
              <b-field label="Teléfono*"
                ><b-input v-model="phone" required></b-input
              ></b-field>

              <b-field label="Provincia*">
                <b-select
                  @input="
                    () => {
                      const matchProvince = provinces.data.find(
                        (p) => p.toLowerCase() === province?.toLowerCase()
                      );
                      if (matchProvince) province = matchProvince;
                      getCities();
                    }
                  "
                  v-model="province"
                  required
                >
                  <option v-for="(p, i) in provinces.data" :key="i" :value="p">
                    {{ p }}
                  </option>
                </b-select>
              </b-field>

              <b-field label="Ciudad*">
                <b-select
                  @input="
                    () => {
                      const matchCity = cities.data.find(
                        (c) => c.toLowerCase() === city?.toLowerCase()
                      );
                      if (matchCity) city = matchCity;
                    }
                  "
                  v-model="city"
                  required
                  :disabled="cities.disabled"
                >
                  <option v-for="(c, i) in cities.data" :key="i" :value="c">
                    {{ c }}
                  </option>
                </b-select>
              </b-field>

              <b-field label="Dirección*"
                ><b-input v-model="address" required></b-input
              ></b-field>
              <b-field label="Cuil*"
                ><b-input v-model="cuil" maxlength="11" required></b-input
              ></b-field>

              <!-- Campos extra -->
              <b-field label="Tipo"><b-input v-model="type"></b-input></b-field>
              <b-field label="DNI"><b-input v-model="dni"></b-input></b-field>
              <b-field label="Plan"><b-input v-model="plan"></b-input></b-field>
              <b-field label="Delegación"
                ><b-input v-model="delegation"></b-input
              ></b-field>
              <b-field label="Número Afiliado"
                ><b-input v-model="num_affiliate"></b-input
              ></b-field>
              <b-field label="Edad"><b-input v-model="age"></b-input></b-field>
              <b-field label="Nacionalidad"
                ><b-input v-model="nacionality"></b-input
              ></b-field>
              <b-field label="Fecha de Nacimiento"
                ><b-input v-model="date_birth" type="date"></b-input
              ></b-field>
              <b-field label="Estado Civil">
                <b-select v-model="civil_status">
                  <option value="Soltero">Soltero</option>
                  <option value="Casado">Casado</option>
                  <option value="Divorciado">Divorciado</option>
                </b-select>
              </b-field>
              <b-field label="Trabajo"
                ><b-input v-model="work"></b-input
              ></b-field>
              <b-field label="No Docente"
                ><b-input v-model="not_teacher"></b-input
              ></b-field>
              <b-field label="Altura"
                ><b-input v-model="height"></b-input
              ></b-field>
              <b-field label="Peso"
                ><b-input v-model="weight"></b-input
              ></b-field>
              <b-field label="IMC"><b-input v-model="imc"></b-input></b-field>
              <b-field label="FUM"
                ><b-input v-model="fum" type="date"></b-input
              ></b-field>
              <b-field label="Cobertura"
                ><b-input v-model="coverage"></b-input
              ></b-field>
              <b-field label="Usuario Social"
                ><b-input v-model="username"></b-input
              ></b-field>
              <b-field label="Teléfono Trabajo"
                ><b-input v-model="work_phone"></b-input
              ></b-field>
              <b-field label="Email Trabajo"
                ><b-input v-model="work_email" type="email"></b-input
              ></b-field>
              <b-field label="Comentarios"
                ><b-input v-model="comments"></b-input
              ></b-field>
              <b-field label="Relación"
                ><b-input v-model="relationship"></b-input
              ></b-field>

              <hr />
              <div class="buttons">
                <b-button native-type="submit" type="is-primary" expanded
                  >Guardar</b-button
                >
              </div>
            </form>
          </b-tab-item>
          <b-tab-item label="Tickets">
            <ContactTickets :contact-id="id" />
          </b-tab-item>

          <b-tab-item label="Ventas">
            <ContactSales :contact-id="id" />
          </b-tab-item>
        </b-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import Loader from "./Loader.vue";
import ContactTickets from "@/components/ContactTickets.vue";
import ContactSales from "@/components/ContactSales.vue";
import {
  alertSuccess,
  alertFailed,
  alertInfo,
  provinces,
  cities,
} from "@/helpers";
export default {
  name: "AgentForm",
  components: {
    Loader,
    ContactTickets,
    ContactSales,
  },

  data() {
    return {
      id: "",
      type: "",
      fullname: "",
      email: "",
      characteristic_phone: "",
      phone: "",
      characteristic_celphone: "",
      celphone: "",
      province: "",
      city: "",
      address: "",
      cuil: "",
      age: "",
      nacionality: "",
      date_birth: "",
      civil_status: "",
      departament: "",
      characteristic_work_phone: "",
      work_phone: "",
      work_email: "",
      work: "",
      not_teacher: "",
      weight: "",
      height: "",
      imc: "",
      fum: "",
      origin: "",
      social_account: "",
      account: "",
      extra_contacts: [],
      coverage: "",
      phone_id: "",
      username: "",
      delegation: "",
      num_affiliate: "",
      plan: "",
      dni: "",
      start_date: "",
      termination_date: "",
      active: "",
      comments: "",
      relationship: "",
      loading: false,
      provinces: { data: [] },
      cities: { data: [], disabled: false },
    };
  },
  methods: {
    async fetchContact() {
      try {
        this.loading = true;
        const id = this.$route.params.id;
        const { data } = await this.$repositories.contacts.show(id);
        const contact = data.contact;

        // Recorremos todas las propiedades devueltas por la API
        Object.keys(contact).forEach((key) => {
          if (this.hasOwnProperty(key)) {
            this[key] = contact[key] ?? "";
          }
        });

        // Manejo especial para extra_contacts (parsear JSON si no está vacío)
        if (contact.extra_contacts) {
          try {
            this.extra_contacts = JSON.parse(contact.extra_contacts);
          } catch {
            this.extra_contacts = [];
          }
        }

        this.getProvinces();
        this.getCities();
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    async fetchTickets() {
      try {
        const query = await this.$repositories.contacts.tickets(this.id);
        query.data.tickets.forEach((item) => {
          const ITEMS = {
            id: item.id,
            departament: item.departament,
            date: item.date,
          };
          this.tickets.data.push(ITEMS);
        });
      } catch (error) {
        console.log(error);
      }
    },

    async update() {
      try {
        this.loading = true;
        const id = this.id;
        const data = new FormData();
        data.append("_method", "put");

        // Recorremos todos los campos que tenemos en data()
        const fields = [
          "type",
          "fullname",
          "email",
          "characteristic_phone",
          "phone",
          "characteristic_celphone",
          "celphone",
          "province",
          "city",
          "address",
          "cuil",
          "age",
          "nacionality",
          "date_birth",
          "civil_status",
          "departament",
          "characteristic_work_phone",
          "work_phone",
          "work_email",
          "work",
          "not_teacher",
          "weight",
          "height",
          "imc",
          "fum",
          "origin",
          "social_account",
          "account",
          "extra_contacts",
          "coverage",
          "phone_id",
          "username",
          "delegation",
          "num_affiliate",
          "plan",
          "dni",
          "start_date",
          "termination_date",
          "active",
          "comments",
          "relationship",
        ];

        fields.forEach((field) => {
          let value = this[field];
          if (field === "extra_contacts") {
            value = JSON.stringify(value);
          }
          data.append(field, value ?? "");
        });

        await this.$repositories.contacts.update(id, data);
        alertSuccess("Registro exitoso!");
      } catch (error) {
        alertFailed("Ha ocurrido un error!");
      } finally {
        this.loading = false;
      }
    },

    async destroy() {
      try {
        this.loading = true;
        const id = this.id;
        await this.$repositories.departaments.delete(id);
        alertInfo("Se ha eliminado correctamente!");
        this.$router.push("/departamentos");
      } catch (error) {
        this.loading = false;
        alertFailed("Ha ocurrido un error!");
      }
    },
    actionForm() {
      this.$route.params.id ? this.update : this.create;
    },
    getProvinces() {
      this.provinces.data = provinces();

      const match = this.provinces.data.find(
        (p) => p.toLowerCase() === this.province?.toLowerCase()
      );
      if (match) {
        this.province = match; // el valor exacto que aparece en el <option>
      }
    },

    getCities() {
      this.cities.data = cities(this.province);
      this.cities.disabled = false;

      const match = this.cities.data.find(
        (c) => c.toLowerCase() === this.city?.toLowerCase()
      );
      if (match) {
        this.city = match;
      }
    },
  },
  async created() {
    await this.fetchContact();
    this.fetchTickets();
  },
};
</script>

<style lang="scss">
#contact-form {
  height: 100vh;
  padding-top: 1.5rem;
  padding-left: 1rem;
  padding-right: 1rem;
  overflow-y: auto;
  form {
    input,
    select,
    textarea {
      border: none;
      &[disabled] {
        border: 1px solid #b5b5b5;
      }
    }
    input,
    select,
    textarea {
      &.is-danger {
        border: 1px solid $danger;
      }
    }
  }
  .menu-list {
    li {
      padding: 1rem 0;
      border-bottom: 1px solid $grey-lighter;
      p {
        margin-bottom: 0;
      }
      a {
        padding-bottom: calc(0.5em - 1px) !important;
        padding-left: 1em !important;
        padding-right: 1em !important;
        padding-top: calc(0.5em - 1px) !important;
      }
      &:first-child {
        padding-top: 0;
      }
    }
  }
  hr {
    background-color: #e8e8e8 !important;
  }
}
</style>